import { boardOrderedIssueIdsSelector } from '../../state/selectors/issue/board-issue-selectors.tsx';
import {
	getIsCMPBoard,
	getOrderedColumnIds,
} from '../../state/selectors/software/software-selectors.tsx';
import { workFilteredIssuesSelector } from '../../state/selectors/work/work-selectors.tsx';
import type { State } from '../../state/types.tsx';

export const getBoardExtraData = (state: State) => ({
	issuesCount: boardOrderedIssueIdsSelector(state).length,
	filteredIssuesCount: workFilteredIssuesSelector(state).length,
	columnsCount: getOrderedColumnIds(state).length,
	isCompanyManaged: getIsCMPBoard(state),
});
